/** Matches API `LegacyNavDeniedReason`. */
export enum LegacyNavDeniedReason {
  None = 0,
  NotSubscribed = 1,
  PermissionDenied = 2,
  NotOwner = 3,
  UnderDevelopment = 4,
  OrganisationDisabled = 5,
}

/** Matches API `LegacyBlazorNavVisibility` from GetLegacyBlazorNavVisibility (Blazor MainLayout drawer rules). */
export type LegacyBlazorNavVisibility = {
  showQualityCalendar: boolean;
  qualityCalendarDeniedReason?: LegacyNavDeniedReason;
  showKpi: boolean;
  showKpiEditor?: boolean;
  kpiDeniedReason?: LegacyNavDeniedReason;
  showLibrary: boolean;
  libraryDeniedReason?: LegacyNavDeniedReason;
  showResources: boolean;
  resourcesDeniedReason?: LegacyNavDeniedReason;
  showNotifications: boolean;
  showPartnerControls: boolean;
  partnerControlsDeniedReason?: LegacyNavDeniedReason;
  showDepartmentControls: boolean;
  departmentControlsDeniedReason?: LegacyNavDeniedReason;
};
